module.exports = __webpack_public_path__ + "static/media/button-close.d13d8c6f.svg";